var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapintelLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 116 24.2",
    style: {
      enableBackground: "new 0 0 116 24.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st2{fill:#EAFF2C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.6,17.1c0.8,0,1.6-0.2,2.2-0.7s1.1-1.1,1.4-1.8h2.1c-0.4,1.3-1.1,2.3-2.2,3.1c-1.1,0.8-2.5,1.2-4,1.2 c-1.9,0-3.5-0.7-4.7-2s-1.8-2.9-1.8-4.8c0-1.9,0.6-3.5,1.8-4.8c1.2-1.3,2.8-2,4.7-2c1.5,0,2.9,0.4,4,1.2s1.8,1.8,2.2,3.1h-2.1 c-0.3-0.8-0.8-1.4-1.4-1.8c-0.6-0.5-1.4-0.7-2.2-0.7S30,7.2,29.4,7.5c-0.6,0.3-1.1,0.6-1.5,1.1c-0.9,0.9-1.3,2.1-1.3,3.5 s0.4,2.6,1.3,3.5C28.9,16.6,30.1,17.1,31.6,17.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.1,16.5c-1.1,1.5-2.6,2.3-4.7,2.3c-1.9,0-3.4-0.7-4.6-2C39.6,15.6,39,14,39,12.1s0.6-3.5,1.7-4.8 c1.2-1.3,2.8-2,4.8-2s3.5,0.8,4.6,2.3V5.5h2v13.1h-2V16.5z M45.7,17.1c1.4,0,2.5-0.5,3.4-1.5c0.8-0.9,1.2-2.1,1.2-3.5 s-0.4-2.6-1.2-3.5c-0.8-1-1.9-1.5-3.4-1.5c-1.4,0-2.5,0.5-3.4,1.5c-0.9,0.9-1.3,2.1-1.3,3.5s0.4,2.6,1.2,3.5 C43.1,16.6,44.3,17.1,45.7,17.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.5,7.6c1.1-1.5,2.6-2.3,4.7-2.3c1.9,0,3.4,0.7,4.6,2c1.2,1.3,1.8,2.9,1.8,4.8c0,1.9-0.6,3.5-1.8,4.8 c-1.2,1.3-2.7,2-4.7,2s-3.5-0.8-4.6-2.3v7.3h-2V5.5h2C57.5,5.5,57.5,7.6,57.5,7.6z M61.9,7.1c-1.4,0-2.5,0.5-3.4,1.5 c-0.8,0.9-1.2,2.1-1.2,3.5s0.4,2.6,1.2,3.5c0.8,1,1.9,1.5,3.4,1.5c1.4,0,2.5-0.5,3.4-1.5c0.8-0.9,1.2-2.1,1.2-3.5s-0.4-2.6-1.2-3.5 C64.4,7.6,63.3,7.1,61.9,7.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.1,5.5h2v13.1h-2V5.5z M73.1,0.7v2.6H71V0.7H73.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.4,5.5v2c0.5-0.6,1.1-1.2,1.7-1.6c0.7-0.4,1.5-0.7,2.3-0.7s1.6,0.1,2.3,0.4c0.6,0.2,1.2,0.6,1.7,1.1 c1.1,1.1,1.6,2.5,1.6,4.2v7.6h-2v-7.4c0-1.2-0.3-2.2-1-2.9s-1.6-1.1-2.7-1.1s-2,0.4-2.8,1.1c-0.8,0.8-1.2,1.7-1.2,2.9v7.6h-2V5.5 H78.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.5,18.6V7.3h-2.7V5.6h2.7V0.9h2v4.7h3v1.7h-3v11.4L92.5,18.6L92.5,18.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.2,17.1c1.8,0,3-0.7,3.8-2.2h2.2c-0.5,1.2-1.2,2.2-2.2,2.9s-2.3,1.1-3.8,1.1c-2,0-3.6-0.7-4.8-2 c-1.2-1.3-1.8-2.9-1.8-4.8c0-1.9,0.6-3.5,1.7-4.8c1.2-1.3,2.8-2,4.8-2s3.6,0.7,4.8,2c1.2,1.3,1.7,2.9,1.7,4.8v0.8h-11 c0.1,1.2,0.6,2.2,1.4,3C102.8,16.7,103.9,17.1,105.2,17.1z M105,7.1c-1.2,0-2.2,0.4-3,1.1c-0.8,0.7-1.2,1.7-1.4,2.8h8.9 c-0.2-1.2-0.6-2.1-1.4-2.8C107.3,7.5,106.3,7.1,105,7.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.9,18.6h-2V0.3h2V18.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.7,18.7l-9.8,2.6V2.5L14.7,6v6.1c0.3-0.1,0.7-0.2,1-0.2s0.6,0.1,0.9,0.2V4.6L0,0v23.9l11.7-3.2V18.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_509_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_510_",
    className: "st2",
    d: "M13.1,21.7h5.3c0.2,0,0.4-0.2,0.4-0.4v-4.5c0-0.2-0.2-0.4-0.4-0.4H18v-1.3 c0-1.2-1-2.3-2.3-2.3s-2.3,1-2.3,2.3v1.2H13c-0.2,0-0.4,0.2-0.4,0.4v4.5C12.7,21.5,12.9,21.7,13.1,21.7z M16.2,19.1v0.5 c0,0.2-0.2,0.4-0.4,0.4s-0.4-0.2-0.4-0.4v-0.5c-0.2-0.1-0.3-0.3-0.3-0.5c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7 C16.4,18.8,16.3,19,16.2,19.1z M14.3,15.1c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v1.2h-2.9L14.3,15.1L14.3,15.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapintelLogo);
export default __webpack_public_path__ + "static/media/capintel-logo.d414e87ae0df2d859ed0b9aed3161a5d.svg";
export { ForwardRef as ReactComponent };